import { createContext, useContext } from 'react'

/**
 * Present only inside the short-link mini-app (/o/:slug). `exitToApp`
 * navigates the ROOT router (v1's ExitShortUrlApp): the mini-app unmounts and
 * the main app takes over — logged out that lands on login, logged in on the
 * target page.
 */
export type ShortLinkContextValue = {
  /** Pathname only (no query/hash) — directly comparable to `location.pathname` */
  entryPathname: string
  exitToApp: (path: string) => void
}

const Context = createContext<ShortLinkContextValue | null>(null)

export const ShortLinkProvider = Context.Provider

export const useShortLinkContext = () => useContext(Context)
